import { useLoginStore, useServicesStore } from '@store';
import { SafeCredentialTypeEnum } from '@types';

import { useAlert } from '../useAlert';

export const useLoginForm = () => {
	const invalidDataAlert = useAlert('invalidData');

	const showCaptcha = !!useServicesStore((store) => store.accountChallenge?.needsCaptcha);
	const { form, resetState, ...loginFormStoreRest } = useLoginStore();

	const { alias, multichannel, password, taxNumber, sms, token, captchaValue } = form || {};

	const handleContinueClick = async (
		onSubmitCallback?: (withCertificate?: boolean, safeCredentialType?: SafeCredentialTypeEnum) => void,
		options?: { withCertificate?: boolean; safeCredentialType?: SafeCredentialTypeEnum }
	) => {
		onSubmitCallback?.(options?.withCertificate, options?.safeCredentialType);
	};

	return {
		alias,
		multichannel,
		sms,
		token,
		password,
		taxNumber,
		showCaptcha,
		captchaValue: captchaValue || '',
		invalidDataAlert,
		onContinueClick: handleContinueClick,
		resetState,
		...loginFormStoreRest,
	};
};
